import styled from '@emotion/styled';
import { Avatar, type AvatarProps } from '@mui/material';
import isPropValid from '@emotion/is-prop-valid';

type ColoredAvatarProps = AvatarProps & {
  size: number;
  marginRight?: number;
  color: string;
};

const ColoredAvatar = styled(Avatar, {
  shouldForwardProp: isPropValid,
})<ColoredAvatarProps>(({ size, marginRight, color, theme }) => {
  const colorWithHighContrastFallback = theme.palette.isHighContrast
    ? theme.palette.divider
    : color;

  return {
    margin: 0,
    marginRight:
      typeof marginRight === 'number' ? marginRight : size / 2 + size / 10,
    color: `${theme.palette.getContrastText(colorWithHighContrastFallback)} !important`,
    backgroundColor: colorWithHighContrastFallback,
    fontWeight: 300,
    textTransform: 'uppercase',
    '&&&': {
      width: size,
      height: size,
      fontSize: size / 2,
    },
  };
});

export default ColoredAvatar;
